<template>
    <svg fill="currentColor" id="logotipo-de-linkedin" xmlns="http://www.w3.org/2000/svg" width="49.183" height="49.183" viewBox="0 0 49.183 49.183">
    <g id="post-linkedin">
        <path id="Path_3" data-name="Path 3" d="M44.265,0H4.918A4.933,4.933,0,0,0,0,4.918V44.265a4.933,4.933,0,0,0,4.918,4.918H44.265a4.933,4.933,0,0,0,4.918-4.918V4.918A4.933,4.933,0,0,0,44.265,0ZM14.755,41.805H7.377V19.673h7.377ZM11.066,15.493a4.426,4.426,0,1,1,4.426-4.426A4.408,4.408,0,0,1,11.066,15.493ZM41.805,41.805H34.428V28.772a3.689,3.689,0,1,0-7.377,0V41.805H19.673V19.673h7.377v2.951A7.944,7.944,0,0,1,33.2,19.181a8.713,8.713,0,0,1,8.607,8.607Z"/>
    </g>
    </svg>

</template>